import RoutesConfig from './RoutesConfig';
import Header from './components/Header';
import Footer from './components/Footer';
import { useEffect, useState } from 'react';
import useApplicationData from './hooks/useApplicationData';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import { AIGeneratedIndicator } from './components/ui/ai-generated-indicator';

function App () {
  const {
    fetchApplicationData,
    fetchTotalApplicationsCount,
    fetchUniqueValues
  } = useApplicationData();
  const location = useLocation();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false); // State for loader
  const noMarginRoutes = ['/analytics']; // add more if needed

  const removeMargin = location.pathname.includes(noMarginRoutes);

  useEffect(() => {
    const fetchData = async () => {
      const accessToken = localStorage.getItem('access_token');
      const refreshToken = localStorage.getItem('refresh_token');

      if (!accessToken || !refreshToken) {
        navigate('/');
        return;
      }

      setIsLoading(true); // Show loader when API call starts

      try {
        await fetchTotalApplicationsCount(accessToken, refreshToken);
        await fetchUniqueValues(accessToken, refreshToken);
        await fetchApplicationData(accessToken, refreshToken);
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false); // Hide loader after ALL API calls complete
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      {/* Loader Overlay */}
      {isLoading && location.pathname !== '/' && (
        <Box
          sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100vw',
            height: '100vh',
            backgroundColor: 'rgba(0, 0, 0, 0.4)', // Transparent grey background
            zIndex: 9999, // Ensures it overlays everything
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          <CircularProgress
            size={60}
            sx={{
              color: '#ea580c'
            }}
          />
        </Box>
      )}

      {/* Main Content */}
      <div className='min-h-screen overflow-hidden bg-gray-100'>
        <Header />
        <div
          className={`relative  ${
            removeMargin ? '' : 'container mb-8 mx-auto'
          }`}
        >
          <RoutesConfig />
          <AIGeneratedIndicator />
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
